import { DIALOG_DATA } from '@angular/cdk/dialog';
import { DIALOG_DIRECTIVES } from '@modules/components/dialog/dialog';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from '@modules/components/button/button.component';
import { FormFieldComponent } from '@modules/components/form-field/form-field.component';

@Component({
  selector: 'app-sql-query-token-dialog',
  imports: [FormFieldComponent, ...DIALOG_DIRECTIVES, MatIconModule, ButtonComponent],
  templateUrl: './sql-query-token-dialog.component.html',
  styleUrl: './sql-query-token-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SqlQueryTokenDialogComponent {
  token = inject<string>(DIALOG_DATA);

  copied = signal(false);

  copy() {
    navigator.clipboard.writeText(this.token).then(() => {
      this.copied.set(true);
      setTimeout(() => this.copied.set(false), 2000);
    });
  }
}
